import { createFeatureSelector, createSelector } from "@ngrx/store"
import { createEntityAdapter, EntityState } from "@ngrx/entity"
import { Profile } from "../models/profile"
import * as profileActions from "../actions/profiles"

export const profileAdapter = createEntityAdapter<Profile>();

export interface State extends EntityState<Profile> {
  loading: boolean;
  error: any;
  product: string;
}

export const initialState: State = profileAdapter.getInitialState({
  loading: false,
  error: undefined,
  product: undefined
});

export function reducer(state: State = initialState, action: profileActions.Actions): State {
  switch (action.type) {
    case profileActions.LOAD_ALL:
      {
        return profileAdapter.removeAll({ ...state, loading: true, error: undefined, product: action.product });
      }
    case profileActions.LOAD_ALL_COMPLETE:
      {
        return profileAdapter.addMany(action.payload, { ...state, loading: false, error: undefined });
      }
    case profileActions.LOAD_ALL_ERROR:
      {
        return { ...state, loading: false, error: action.payload };
      }
    default:
      {
        return state;
      }
  }
}
